import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'

type Props = {
  tableProps: PropsWithChildren<HeaderProps<any>>
  isAllSelected: boolean
  onSelectAll: () => void
}

export const SelectionHeader: FC<Props> = (props) => {
  return (
    <th {...props.tableProps.column.getHeaderProps()} className='w-[10px] pe-2'>
      <div className='flex items-center me-3'>
        <input
          type='checkbox'
          className='w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-offset-1 focus:ring-primary'
          data-kt-check={props.isAllSelected}
          data-kt-check-target='#kt_table_academic_years .form-check-input'
          checked={props.isAllSelected}
          onChange={props.onSelectAll}
        />
      </div>
    </th>
  )
}
